import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { AppNotification } from 'context/NotificationCenterContext';
import NotificationToast from './NotificationToast';

interface NotificationToastStackProps {
  toasts: AppNotification[];
  onDismiss: (id: string) => void;
}

const NotificationToastStack = ({ toasts, onDismiss }: NotificationToastStackProps) => {
  if (toasts.length === 0) {
    return null;
  }

  return createPortal(
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1600,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        alignItems: 'flex-end',
        pointerEvents: 'none',
        '& > *': {
          pointerEvents: 'auto',
        },
      }}>
      {toasts.map(toast => (
        <NotificationToast key={toast.id} notification={toast} onDismiss={onDismiss} />
      ))}
    </Box>,
    document.body
  );
};

export default NotificationToastStack;
